import { render, staticRenderFns } from "./ValidSwitcher.vue?vue&type=template&id=bfd9eed2&scoped=true&"
import script from "./ValidSwitcher.vue?vue&type=script&lang=js&"
export * from "./ValidSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd9eed2",
  null
  
)

export default component.exports